import type { WidgetContextExtractorConfig } from "./types";

class WidgetContextRegistryImpl {
  private extractors = new Map<string, WidgetContextExtractorConfig>();

  register(contextId: string, config: WidgetContextExtractorConfig) {
    this.extractors.set(contextId, config);
  }

  unregister(contextId: string) {
    this.extractors.delete(contextId);
  }

  lookup(contextId: string): WidgetContextExtractorConfig | undefined {
    return this.extractors.get(contextId);
  }

  getAll(): Map<string, WidgetContextExtractorConfig> {
    return this.extractors;
  }
}

export const WidgetContextRegistry = new WidgetContextRegistryImpl();
